import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import FeatherIcon from "feather-icons-react";

// AIDEV-NOTE: Reusable confirmation modal component for operations
const ModalConfirmacao = ({
  isOpen,
  toggle,
  onConfirm,
  titulo = "Confirmação",
  mensagem = "Tem certeza que deseja continuar?",
  textoBotaoConfirmar = "Confirmar",
  textoBotaoCancelar = "Cancelar",
  corBotaoConfirmar = "danger",
  icone = "alert-triangle",
}) => {
  const handleConfirmar = () => {
    onConfirm();
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="sm">
      <ModalHeader toggle={toggle}>
        <div className="d-flex align-items-center">
          <FeatherIcon
            icon={icone}
            className={`me-2 text-${corBotaoConfirmar}`}
            size={20}
          />
          {titulo}
        </div>
      </ModalHeader>
      
      <ModalBody>
        <p className="mb-0">{mensagem}</p>
      </ModalBody>
      
      <ModalFooter>
        <Button color="secondary" onClick={toggle} size="sm">
          <FeatherIcon icon="x" className="me-1" size={14} />
          {textoBotaoCancelar}
        </Button>
        <Button color={corBotaoConfirmar} onClick={handleConfirmar} size="sm">
          <FeatherIcon icon="check" className="me-1" size={14} />
          {textoBotaoConfirmar}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalConfirmacao; 